import { create } from '@wix/fedops-logger';
import { COMPONENT_NAME } from '../config';

export enum FedopsInteractions {
  VideoMakerModal = 'video-maker-modal-opened',
  PromoteIframeLoaded = 'promote-iframe-loaded',
  Download = 'download-interaction',
  Delete = 'delete-interaction',
  MyVideosListLoaded = 'my-videos-list-loaded',
}

export interface IFedopsLogger {
  interactionStarted: (name: FedopsInteractions) => void;
  interactionEnded: (name: FedopsInteractions) => void;
  appLoaded: () => void;
}

export const fedopsLogger: IFedopsLogger = create(COMPONENT_NAME);
